/* Etiquetas multiidoma en inglés. */
export default {
  "waitingLayer.loading": "loading",
  "waitingLayer.timeWarning.delay": "It's taking longer than expected.",
  "waitingLayer.timeWarning.wait": "Please stay tuned.",
};
